// extracted by mini-css-extract-plugin
export default {"selected":"navTab_selected__JwM-q","tabStyle":"navTab_tabStyle__3Rfvf"};